module.exports = __webpack_public_path__ + "static/media/HCMM188.d6568e90.jpg";